import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "hooks/useNotification";
import { useState } from "react";
import { deleteTransportSedel } from "api/transportSedel.api";
import { UppdragQueryKey } from "api/uppdrag.api";
import { TransportSedel } from "types/transportSedel.type";

export const useDeleteTransportSedelLogic = (
  transportSedel: TransportSedel
) => {
  const queryClient = useQueryClient();
  const notification = useNotification();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onModalClose = () => setIsModalOpen(false);

  // CREATE
  const mutation = useMutation({
    ...deleteTransportSedel(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [UppdragQueryKey.GetOne],
      });

      onModalClose();
    },
    onError: () => notification.error(),
  });

  const onConfirm = () => mutation.mutate(transportSedel.id);

  return {
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    onConfirm,
    mutation,
    onModalClose,
  };
};

export type DeleteTransportSedelLogicRetVal = ReturnType<
  typeof useDeleteTransportSedelLogic
>;
